import { Pipe, PipeTransform } from '@angular/core';
import { TemplateStatus } from '@app/modules/vault/components/common/common-file-view-with-groups/individual-group-files-list-items/individual-group-files-list-items.component';

@Pipe({
  name: 'getStatusButtonClass',
})
export class GetStatusButtonClass implements PipeTransform {
  private readonly templateStatusButtonClassMap: Record<string, string> = {
    [TemplateStatus.notStarted]: 'status-menu-button-notStarted',
    [TemplateStatus.workingOnIt]: 'status-menu-button-workingOnIt',
    [TemplateStatus.review]: 'status-menu-button-review',
    [TemplateStatus.needsAttention]: 'status-menu-button-needsAttention',
    [TemplateStatus.complete]: 'status-menu-button-complete',
  };

  private readonly templateStatusMenuClassMap: Record<string, string> = {
    [TemplateStatus.notStarted]: 'status-menu-item status-menu-item-notStarted',
    [TemplateStatus.workingOnIt]: 'status-menu-item status-menu-item-workingOnIt',
    [TemplateStatus.review]: 'status-menu-item status-menu-item-review',
    [TemplateStatus.needsAttention]: 'status-menu-item status-menu-item-needsAttention',
    [TemplateStatus.complete]: 'status-menu-item status-menu-item-complete',
  };
  transform(status: TemplateStatus | string | null | undefined, isMenu: boolean = false): string {
    if (isMenu) {
      return this.templateStatusMenuClassMap[status] ?? '';
    } else {
      const key = status ?? TemplateStatus.notStarted;
      return this.templateStatusButtonClassMap[key] ?? '';
    }
  }
}
